import React from "react";
import { ReactComponent as ModalViewIcon } from "../../../assets/icons/layout-modal-view.svg";
import { ReactComponent as SideViewIcon } from "../../../assets/icons/layout-side-view.svg";
import Resizable from "../../resizable/Resizable";
import TicketDetails from "./ticket-details/TicketDetails";
import { DashboardTicketDisplay } from "../../../__generated__/api";
import Button from "../../theme/button/Button";
import Styles from "./Chat.module.scss";
import { TicketItem, useTicketState } from "../../../contexts/ticket-state";

const DEFAULT_SECTIONS = [
    { sectionId: "urn:fq:portal-chat-section:general", isMinimized: false },
    { sectionId: "urn:fq:portal-chat-section:request", isMinimized: false },
    { sectionId: "urn:fq:portal-chat-section:people", isMinimized: false },
    { sectionId: "urn:fq:portal-chat-section:sla", isMinimized: false },
    { sectionId: "urn:fq:portal-chat-section:artificial-intelligence", isMinimized: false },
    { sectionId: "urn:fq:portal-chat-section:tasks", isMinimized: false },
    { sectionId: "urn:fq:portal-chat-section:custom-context", isMinimized: false },
];

const READONLY_SECTIONS = [
    { sectionId: "urn:fq:portal-chat-section:general", isMinimized: false },
    { sectionId: "urn:fq:portal-chat-section:request", isMinimized: false },
];

interface ChatViewSidebarProps {
    ticket: TicketItem;
    onClose: () => void;
    onToggleDisplay?: () => void;
    displayType: DashboardTicketDisplay;
    isReadOnly: boolean;
    metricPathSection: string
}

function ChatViewSidebar({
    ticket,
    onClose,
    onToggleDisplay,
    displayType,
    isReadOnly,
    metricPathSection,
}: ChatViewSidebarProps) {
    const settings = useTicketState();

    const defaultSections = isReadOnly
        ? READONLY_SECTIONS
        : settings.userSettings?.chatSections ?? DEFAULT_SECTIONS;

    return (
        <Resizable direction="w" defaultSize={350} axis="x">
            <div className={Styles["chat-details"]}>
                <div className={Styles["chat-details-header"]}>
                    <h4>Details</h4>
                    <div className={Styles["chat-details-buttons"]}>
                        {onToggleDisplay && (
                            <Button
                                prefixIcon={displayType === DashboardTicketDisplay.Modal ? <SideViewIcon /> : <ModalViewIcon />}
                                variant="ghost-gray"
                                size="small"
                                onClick={onToggleDisplay}
                                metricPath={[
                                    metricPathSection, "chat", "display-type", displayType?.toLowerCase().replace(/ /g, "-"),
                                ]}

                            />
                        )}

                        <Button
                            metricPath={[metricPathSection, "chat", "close"]}
                            isClose
                            variant="ghost-gray"
                            size="small"
                            onClick={onClose}
                        />

                    </div>
                </div>
                <TicketDetails
                    metricPathPrefix={[metricPathSection, "details"]}
                    ticket={ticket}
                    isReadOnly={isReadOnly}
                    defaultSections={defaultSections}
                />
            </div>
        </Resizable>
    );
}

ChatViewSidebar.defaultProps = {
    onToggleDisplay: undefined,
};

export default ChatViewSidebar;
